export default "__VITE_ASSET__B0lY$pUs__"